module.exports = __webpack_public_path__ + "img/mod.610b5e74.svg";